import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import DetailsCard, { type SelectOptions } from "@/components/DetailsCard/DetailsCard";
import { CardSkeleton } from "@/components/Skeleton";
import { formatDate } from "@/pages/_layouts/jobs/_utils";
import type { CareerPlanLatestTab } from "./careerPlanLatest";
import { careerPlanLatestHref } from "./careerPlanLatest";

export default function CareerPlanSummaryCard({
  title,
  testId,
  updatedAt,
  loading,
  pgaId,
  viewAllTab,
  showViewAll = true,
  options = [],
  children
}: {
  title: string;
  testId: string;
  updatedAt?: string | null;
  loading: boolean;
  pgaId?: string;
  viewAllTab?: CareerPlanLatestTab;
  showViewAll?: boolean;
  options?: SelectOptions[];
  children?: ReactNode;
}) {
  return (
    <div className="h-full min-w-0 w-full" data-testid={testId}>
      {loading ? (
        <CardSkeleton className="w-full" width={100} rows={5} />
      ) : (
        <DetailsCard
          heading={title}
          caption={updatedAt ? `Updated ${formatDate(updatedAt)}` : undefined}
          options={options}
          actionButtons={
            pgaId && showViewAll && viewAllTab ? (
              <Link
                to={careerPlanLatestHref(pgaId, viewAllTab)}
                data-testid={`${testId}-view-all`}
                aria-label={`View ${title}`}
                className="mt-2 inline-flex min-h-10 items-center text-label-large text-sys-brand-primary"
              >
                View
              </Link>
            ) : undefined
          }
        >
          {children}
        </DetailsCard>
      )}
    </div>
  );
}
